import { defaultTheme } from 'retro-react';
  
const MyTheme = { 
  ...defaultTheme, 
  colors: { 
    ...defaultTheme.colors, 
    primary: '#41a8d7', 
    secondary: '#3f8bae', 
    success: '#0000ff', 
    error: '#ffff00', 
    warn: '#00ffff', 
    }, 
  };
  
  export default MyTheme;
